import { render } from "./FpCheckbox.vue?vue&type=template&id=997ddd1c&scoped=true"
import script from "./FpCheckbox.vue?vue&type=script&lang=js"
export * from "./FpCheckbox.vue?vue&type=script&lang=js"

import "./FpCheckbox.vue?vue&type=style&index=0&id=997ddd1c&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997ddd1c"]])

export default __exports__